import Request from '@/plugins/request';

export function getSaleGoodsDailyStats(params) {
  return Request.get('sale-goods-daily-stats', { params })
}

export function createSaleGoodsDailyStat() {
  return Request.get(`sale-goods-daily-stats/create`)
}

export function storeSaleGoodsDailyStat(data) {
  return Request.post('sale-goods-daily-stats', data)
}

export function updateSaleGoodsDailyStat(id, data) {
  return Request.put(`sale-goods-daily-stats/${id}`, data)
}

export function editSaleGoodsDailyStat(id) {
  return Request.get(`sale-goods-daily-stats/${id}/edit`)
}

export function destroySaleGoodsDailyStat(id) {
  return Request.delete(`sale-goods-daily-stats/${id}`)
}

export function getTopData(params) {
  return Request.get('sale-goods-daily-stats/get-top-data', { params })
}
